// get_acticle
export const GET_ACTICLE = 'get_acticle';
export const GET_ACTICLE_SUCCESSFUL = 'get_acticle_successfull';
export const GET_ACTICLE_FAILED = 'get_acticle_failed';

// create_acticle
export const CREATE_ACTICLE = 'create_acticle';
export const CREATE_ACTICLE_SUCCESSFUL = 'create_acticle_successfull';
export const CREATE_ACTICLE_FAILED = 'create_acticle_failed';

// update_acticle
export const UPDATE_ACTICLE = 'update_acticle';
export const UPDATE_ACTICLE_SUCCESSFUL = 'update_acticle_successfull';
export const UPDATE_ACTICLE_FAILED = 'update_acticle_failed';

// delete_acticle
export const DELETE_ACTICLE = 'delete_acticle';
export const DELETE_ACTICLE_SUCCESSFUL = 'delete_acticle_successfull';
export const DELETE_ACTICLE_FAILED = 'delete_acticle_failed';
